import axios from '@axios'
export const state = {
  category: [],
  currentPage: 0,
  perPage: 15,
  totalPages: 0,
  totalRecords: 0,
}

export const getters = {
  allCategories: (state) => state.category,
  currentPage: (state) => state.currentPage,
  totalPages: (state) => state.totalPages,
  perPage: (state) => state.perPage,
  totalRecords: (state) => state.totalRecords,
}

export const mutations = {
  GET_CATEGORIES: (state, data) => {
    state.category = data.categories
    state.currentPage = data.page
    state.perPage = data.perPage
    state.totalPages = data.totalPages
    state.totalRecords = data.totalRecords
  },

  CREATE_CATEGORY: (state, category) => {
    state.category.unshift(category)
  },

  UPDATE_CATEGORY: (state, category) => {
    state.category = state.category.filter(c => c.id !== category.id)
    state.category.unshift(category)
  },

  REMOVE_CATEGORY: (state, category) => {
    state.category = state.category.filter(c => c.id !== category.id)
  },

}

export const actions = {

  async getCategories({ commit }) {
    await axios
      .get(`/announcements/categories`)
      .then((resp) => {
        if (resp.status === 200) {
          let data = resp.data
          commit('GET_CATEGORIES', data)
        }
      })
  },
  async createCategory({ commit }, category) {
    await axios.post('/announcement/category', category).then((response) => {
      console.log(response.status);
      if (response.status === 201) {
        commit('CREATE_CATEGORY', response.data)
      }
    })
  },

  async updateCategory({ commit }, category) {
    commit('UPDATE_CATEGORY', category);
  },

  async removeCategory({ commit }, categoryId) {
    commit('REMOVE_CATEGORY', categoryId);
  },
}


